import type { Capitolo } from '../tipi.ts'

const capitolo: Capitolo = {
  id: 'enti',
  titolo: 'Enti e referenti',
  gruppo: 'Rete e progetti',
  permesso: 'ente.leggi',
  aCheServe: 'La voce «Enti» è l’anagrafica degli enti con cui CIDIS lavora: profilo, contatti, dipartimenti e '
    + 'referenti. Serve al registro dei servizi, ai progetti e alle attività collettive.',
  parti: [
    {
      titolo: 'Trovare un ente',
      passi: [
        'Apri «Enti». Nel campo «Cerca» scrivi il nome o l’acronimo.',
        'Restringi con «Profilo ente», «Sede CIDIS», «Stato» e «Comune».',
        'Premi il nome per aprire la scheda dell’ente: anagrafica, contatti, dipartimenti, referenti, progetti e '
          + 'ultimi servizi erogati.',
      ],
      immagine: {
        file: 'enti.webp', larghezza: 1200, altezza: 760,
        descrizione: 'L’elenco degli enti con il campo Cerca e i filtri.',
      },
    },
    {
      titolo: 'Inserire un ente nuovo',
      permesso: 'ente.gestisci',
      passi: [
        'Premi «Nuovo ente». Mentre scrivi il nome, il gestionale mostra gli enti simili già registrati: '
          + 'controlla che non ci sia già.',
        'Compila «Nome completo ufficiale» e «Profilo ente»; se li sai, «Finanziatore?» e «Partner formale?».',
        'In «Dipartimenti, settori e filiali» scrivi un nome e premi «Aggiungi», per ognuno.',
        'Compila sede legale e contatti. Il telefono va in formato internazionale, per esempio +39 075 5720895.',
        'In «Referenti» scrivi nome, cognome, funzione e contatti, poi «Aggiungi il referente».',
        'Premi «Inserisci l’ente».',
      ],
      nota: 'Se il nome contiene «CIDIS» il gestionale chiede conferma: le sedi CIDIS non sono enti.',
    },
    {
      titolo: 'Referenti e dipartimenti',
      permesso: 'ente.gestisci',
      testo: [
        'Nella scheda dell’ente, riquadro «Referenti», premi «Aggiungi un referente», oppure «Modifica» e '
          + '«Disattiva» su uno che c’è. Lo stesso nel riquadro «Dipartimenti, settori e filiali».',
        'Un referente si aggiunge anche mentre registri un servizio, con «Aggiungi un referente», senza lasciare '
          + 'il modulo.',
      ],
    },
    {
      titolo: 'Unire gli enti registrati due volte',
      permesso: 'ente.gestisci',
      passi: [
        'Nella pagina «Enti» premi «Unisci i doppioni»: la finestra propone gli enti che probabilmente sono lo stesso.',
        'Premi «Rivedi» sul gruppo e scegli l’ente da tenere.',
        'Premi «Controlla l’unione» e leggi l’anteprima: che cosa passa all’ente tenuto e che cosa resta.',
        'Premi «Unisci gli enti».',
      ],
      immagine: {
        file: 'enti-unisci.webp', larghezza: 1200, altezza: 800,
        descrizione: 'La finestra Probabili doppioni degli enti, con il comando Rivedi.',
      },
      nota: 'Se due enti sono lo stesso ma non compaiono fra le proposte, apri quello da tenere e premi «Unisci con '
        + 'un altro ente». L’unione non si annulla dalla pagina.',
    },
  ],
  avvertenze: [
    {
      quando: '«Profilo dell’ente non indicato: completalo con «Modifica».»',
      cosaFare: 'Premi «Modifica» sull’ente e scegli il profilo.',
    },
    {
      quando: 'Un telefono porta l’etichetta «non in formato internazionale».',
      cosaFare: 'Correggilo con il prefisso del paese, per esempio +39.',
    },
    {
      quando: '«L’ente che hai aperto è stato unito a questo: i suoi dati sono qui.»',
      cosaFare: 'L’ente era un doppione: lavora su questo.',
    },
  ],
  vediAnche: ['registro-servizi', 'progetti', 'attivita-collettive'],
  parole: ['ente', 'stakeholder', 'referente', 'dipartimento', 'filiale', 'partner', 'finanziatore', 'doppioni', 'unisci'],
}

export default capitolo
